import { validateErrMessages } from "./constant";
import { isValidPhoneNumber } from 'react-phone-number-input';
import i18next from 'i18next';

export default {
  checkMobileEmail: ({ getFieldValue }) => ({
    validator(_, value) {
      if (value) {
        let isValid = String(value).trim().toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        if (isValid) {
          return Promise.resolve();
        } else {
          let zero_not_allowed = String(value).trim().toLowerCase().match(/^(?:[1-9]\d*|0)$/);
          let isValid = String(value).trim().toLowerCase()
          .match(
            /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/
          );
        if (isValid && zero_not_allowed) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error('Please enter valid Email/Mobile number'));
        }

        }
      }
      return Promise.resolve();
    },
  }),
  checkMobileEmailwithcountry: (country_code) => ({
    validator(_, value) {
      if (value) {
        let isValid = String(value).toLowerCase().trim()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        if (isValid) {
          return Promise.resolve();
        } else {
          if(isValidPhoneNumber(country_code+value)){
            return Promise.resolve();
          } else {
            return Promise.reject(new Error('Country code and mobile number does not match'));
          }
        }
      }
      return Promise.resolve();
    },
  }),
  checkEmail: ({ getFieldValue }) => ({
    validator(_, value) {
      if (value) {
        let isValid = String(value).trim().toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        if (isValid) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error(i18next.t(validateErrMessages.checkEmailMessage, { lng: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" })));
        }
      }
      return Promise.resolve();
    },
  }),
  checkCareMobileNumber: ({ getFieldValue }) => ({
    validator(_, value) {
      if (value) {
        let isValid = String(value).toLowerCase().trim()
          .match(
            /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/
          );
        if (isValid) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error(validateErrMessages.checkMobileNumberMessage));
        }
      }
      return Promise.resolve();
    },
  }),
  checkMobileNumber: ({ getFieldValue }) => ({
    validator(_, value) {
      if (value) {
        let zero_not_allowed = String(value).toLowerCase().trim().match(/^(?:[1-9]\d*|0)$/);
        let isValid = String(value).toLowerCase()
          .match(
            /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/
          );
        if (isValid && zero_not_allowed) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error(validateErrMessages.checkMobileNumberMessage));
        }
      }
      return Promise.resolve();
    },
  }),
  checkValidDiscount: ({ getFieldValue }) => ({
    validator(_, value) {
      if (value.trim()) {
        let parsedValue = parseFloat(value);
        let discount = !isNaN(parsedValue) && Number.isFinite(parsedValue) && parsedValue >= 0 && parsedValue <= 100; 
        let isValid = String(value).toLocaleLowerCase().match(/^\s*(?=.*[1-9])\d*(?:\.\d{1,4})?\s*$/);
        if ( isValid && discount) {
          return Promise.resolve();
        } else {
          if(!isValid)
          return Promise.reject(new Error(validateErrMessages.validateIsNumber));
          if(!discount){
            return Promise.reject(new Error(validateErrMessages. checkValidDiscountMessage));
          }
        }
    
         
      }
      return Promise.resolve();
    },
  }),
  validateIsNumber: (obj) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).toLowerCase().match(/^[0-9]*$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateIsNumber));

      }
      return Promise.resolve();
    },
  }),
  checkOnlyNumber: (obj) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).toLowerCase().match(/^[0-9]*$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateIsNumber));

      }
      return Promise.resolve();
    },
  }),
  
  checkDecimal: (obj) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).toLocaleLowerCase().match(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validErrorMessage));
      }
      return Promise.resolve();
    },
  }),
  checkDecimalPrescription : (translation = true, tgtLang = null) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).toLocaleLowerCase().match(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error( translation ? i18next.t(validateErrMessages.documentNumberGreaterThanZero, { lng: tgtLang ? tgtLang : window?.store?.getState().loginReducer?.user_details.language +"_en" || "" }) : validateErrMessages.documentNumberGreaterThanZero))
      }
      return Promise.resolve();
    },
  }),
  checkDecimalWithZero: (obj) => ({  
    validator(name, value) {
      if (value) {

          let isValid = true;

          if ((value[1] == undefined || value[1] == "")){
          }else if (String(value[1]).toLocaleLowerCase().match(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/) == null){
            isValid = false;
          }

          if ((value[2] == undefined || value[2] == "")){ 
          }else if(String(value[2]).toLocaleLowerCase().match(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/) == null){
            isValid = false;
          }

          if ((value[3] == undefined || value[3] == "")){
          }else if(String(value[3]).toLocaleLowerCase().match(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/) == null){
            isValid = false;
          }

          if ((value[4] == undefined || value[4] == "")){
          }else if(String(value[4]).toLocaleLowerCase().match(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/) == null){
            isValid = false;
          }

          if(obj.type != "allopathy" && isValid){
            // if(value[1] != undefined && value[2] != undefined && value[3] != undefined && value[4] != undefined){
              if(value["measure"] == null){
                // isValid = false;
                // return Promise.reject(new Error("Please fill the unit")); 
              }else{
                Promise.resolve();
              }
            // }
          }
           
        if (isValid) { 
          Promise.resolve();
        }
        else if(isValid == false) return Promise.reject(new Error(validateErrMessages.validErrorMessage));

        // if(value[1] == undefined  || value[2] == undefined || value[3] == undefined|| value[4] == undefined || value[1] == "" || value[2] == "" || value[3] == ""|| value[4] == ""){
        //   return Promise.reject(new Error("Please fill out all four frequencies."));
        // }else{
        //   Promise.resolve();
        // }
      
      }
      return Promise.resolve();
    },
  }
  ),

  checkDecimalWithZeroFormMedicine: (obj) => ({  
    validator(name, value) {
      if (value) {

        let isValid = true;

        if ((value[1] == undefined || value[1] == "")){
        }else if (String(value[1]).toLocaleLowerCase().match(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/) == null){
          isValid = false;
        }

        if ((value[2] == undefined || value[2] == "")){ 
        }else if(String(value[2]).toLocaleLowerCase().match(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/) == null){
          isValid = false;
        }

        if ((value[3] == undefined || value[3] == "")){
        }else if(String(value[3]).toLocaleLowerCase().match(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/) == null){
          isValid = false;
        }

        if ((value[4] == undefined || value[4] == "")){
        }else if(String(value[4]).toLocaleLowerCase().match(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/) == null){
          isValid = false;
        }

        if(obj.type != "allopathy" && isValid){
          // if(value[1] != "" && value[2] != "" && value[3] != "" && value[4] != ""){
            if(value["measure"] == ""){
              // isValid = false;
            }else{
              // isValid = true;
            }
          // }
        }
         
      if (isValid) { 
        Promise.resolve();
      }
      else if(isValid == false) return Promise.reject(new Error(validateErrMessages.validErrorMessage));
    
    // }
     }

    //  if(value[1] == "" && value[2] == "" && value[3] == "" && value[4] == ""){
    //   return Promise.reject(new Error("Please fill the frequency"));
    // }else if( (value[1].length == 0 || value[2].length == 0 || value[3].length == 0 || value[4].length == 0) || 
    //  !(value[1].length !=0 && value[2].length != 0 && value[3].length != 0 && value[4].length != 0)
    //  ){
    //   return Promise.reject(new Error("Please fill out all four frequencies."));
    //   }
    //   else{
    //     Promise.resolve();
    //   }
      return Promise.resolve();
    },
  }
  ),
  ihiDurationValidator:(obj) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).toLocaleLowerCase().match(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.documentNumberIsNumber));
      }
      return Promise.resolve();
    },
  }),

  checkMaxLimits: (obj) => ({
    validator(name, value) {
      if (value) {
        let limit = 1000;
        if(name.field.includes("dosage")) limit = 1000;
        if(name.field.includes("number_of_close_friends")) limit = 1000;
        if(name.field.includes("number_of_years")) limit = 99;
        if(name.field.includes("duration")) limit = 100;
        let isValid = String(value) <= limit;
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.maxLimitErrorMessage));

      }
      return Promise.resolve();
    },
  }),
  checkStringLength: (obj) => ({
    validator(name, value) {
      if (value) {
        let length = 100;
        if(name.field.includes("reason_for_relapse") || name.field.includes("description")) length = 100;
        if(name.field.includes("frequency")) length = 5;
        let isValid = value.trim().length <= length;
        if (isValid) return Promise.resolve();
        else{
          if (length == 100){
            return Promise.reject(new Error(i18next.t(validateErrMessages.length100ErrorMessage, { lng: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" } )));
            
          }
          else return Promise.reject(new Error(i18next.t(validateErrMessages.lengthErrorMessage, { lng: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" })));  
        }
      }
      return Promise.resolve();
    },
  }),
  checkStringDescriptionLength: (translation=true) => ({
    validator(name, value) {
      if (value) {
        let length = 100;
        if(name.field.includes("reason_for_relapse") || name.field.includes("description") || name.field.includes("reason_words")) length = 250;
        if(name.field.includes("frequency")) length = 5;
        let isValid = value.trim().length <= length;
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(
          translation ?
          i18next.t(validateErrMessages.length250ErrorMessage, { lng: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" }):
          validateErrMessages.length250ErrorMessage
          ));

      }
      return Promise.resolve();
    },
  }),
  checkNegativeNumbers: (obj) => ({
    validator(name, value) {
      if (value) {
        let isValid = !value.trim().startsWith("-");
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.negativeValueMessage));

      }
      return Promise.resolve();
    },
  }),
  validateIsAlphaNumeric: ({ getFieldName, getFieldValue }) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).toLowerCase().match(/^[a-zA-Z0-9 .,-@_#]*$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateIsAlphaNumeric));
      }
      return Promise.resolve();
    },
  }),
  validateIsDietTab: ({ getFieldName, getFieldValue }) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).toLowerCase().match(/^[a-zA-Z0-9 ./,();\-:_&]*$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateIsAlphaNumeric));
      }
      return Promise.resolve();
    },
  }),
  
  validateValuePresent: ({ getFieldName, getFieldValue }) => ({
    validator(name, value) {
      const trimmedvalue = value?.trim();
      if (trimmedvalue) {
        return Promise.resolve();
      }else{
        return Promise.reject(new Error(validateErrMessages.validateField));
      }
    },
  }),

validateFirstName: (elseFlag = true, translation = true, tgtLang = null) => ({
  validator(name, value) {
    const lng =
      tgtLang ??
      window?.store?.getState().loginReducer?.user_details.language + "_en";

    // Check the original value for consecutive spaces BEFORE trimming
    if (value && /\s{2,}/.test(value)) {
      return Promise.reject(
        new Error(
          i18next.t(
            validateErrMessages.consecutiveSpacesNotAllowed,
            { lng }
          )
        )
      );
    }

    const trimmedFirstName = value?.trim();

    if (trimmedFirstName) {
      // Check length constraints
      if (trimmedFirstName.length < 3) {
        return Promise.reject(
          new Error(
            i18next.t(
              validateErrMessages.minLengthValidation,
              { lng }
            )
          )
        );
      }

      if (trimmedFirstName.length > 50) {
        return Promise.reject(
          new Error(
            i18next.t(
              validateErrMessages.firstNameLastNameValidation,
              { lng }
            )
          )
        );
      }

      // 🚫 Consecutive dots not allowed
      if (/\.{2,}/.test(trimmedFirstName)) {
        return Promise.reject(
          new Error(
            i18next.t(
              validateErrMessages.consecutiveDotsNotAllowed,
              { lng }
            )
          )
        );
      }

      // ✅ Must contain at least one alphabet
      if (!/[A-Za-z]/.test(trimmedFirstName)) {
        return Promise.reject(
          new Error(
            i18next.t(
              validateErrMessages.minOneAlphabetRequired,
              { lng }
            )
          )
        );
      }

      // ✅ Only alphabets, spaces, and dots allowed
      // Must start with an alphabet
      const isValid = /^[A-Za-z][A-Za-z\s.]*$/.test(trimmedFirstName);

      if (!isValid) {
        return Promise.reject(
          new Error(
            i18next.t(
              validateErrMessages.SpecialCharecterValidation,
              { lng }
            )
          )
        );
      }

      return Promise.resolve();
    }

    if (elseFlag) {
      return Promise.reject(
        new Error(
          i18next.t(
            validateErrMessages.validateField,
            { lng }
          )
        )
      );
    }

    return Promise.resolve();
  },
}),

validateLastName: (tgtLang = null) => () => ({
  validator(name, value) {
    const lng =
      tgtLang ??
      window?.store?.getState().loginReducer?.user_details.language + "_en";

    // Check the original value for consecutive spaces BEFORE trimming
    if (value && /\s{2,}/.test(value)) {
      return Promise.reject(
        new Error(
          i18next.t(
            validateErrMessages.consecutiveSpacesNotAllowed,
            { lng }
          )
        )
      );
    }

    const trimmedLastName = value?.trim();

    if (trimmedLastName) {
      // Check max length
      if (trimmedLastName.length > 50) {
        return Promise.reject(
          new Error(
            i18next.t(
              validateErrMessages.firstNameLastNameValidation,
              { lng }
            )
          )
        );
      }

      // 🚫 Consecutive dots not allowed
      if (/\.{2,}/.test(trimmedLastName)) {
        return Promise.reject(
          new Error(
            i18next.t(
              validateErrMessages.consecutiveDotsNotAllowed,
              { lng }
            )
          )
        );
      }

      // ✅ Must contain at least one alphabet
      if (!/[A-Za-z]/.test(trimmedLastName)) {
        return Promise.reject(
          new Error(
            i18next.t(
              validateErrMessages.minOneAlphabetRequired,
              { lng }
            )
          )
        );
      }

      // ✅ Only alphabets, spaces, and dots allowed
      // Must start with an alphabet
      const isValid = /^[A-Za-z][A-Za-z\s.]*$/.test(trimmedLastName);

      if (!isValid) {
        return Promise.reject(
          new Error(
            i18next.t(
              validateErrMessages.SpecialCharecterValidation,
              { lng }
            )
          )
        );
      }

      return Promise.resolve();
    }

    return Promise.resolve();
  },
}),


  checkAlphaNumericSpecialCharacters: ({translation=true, tgtLang=null}) => ({
    validator(name, value) {
      if (value) {
        let tempString = value.replace(/[\n\r]/g, "")
        let isValid = String(tempString).toLowerCase().match(/^[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/);
        isValid = String(isValid).trim()
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error( translation ?i18next.t(validateErrMessages.validateIsAlphaNumeric, { lng: tgtLang ? tgtLang : localStorage.getItem("language") +"_en" || "" }):validateErrMessages.validateIsAlphaNumeric));
              }
      return Promise.resolve();
    },
  }),

  checkAlphabetsNumbers: () => ({
    validator(name, value){
      if(value){
      value = String(value).trim()
      let isValid = String(value).toLowerCase().match(/^[a-zA-Z0-9]+$/);
      if (isValid) return Promise.resolve();
      else return Promise.reject(new Error(validateErrMessages.documentNumberIsAlphaNumeric))
      }
      return Promise.resolve();
    }
  }),

  checkValidComments: ()=>({
    validator(name, value) {
      if (value) {
        // let isValid = String(value.trim()).toLowerCase().match(/^[a-zA-Z0-9"#$%&'()*+,-./:;<=>?@\s./][a-zA-Z0-9"#$%&'()*+,-./:;<=>?@\s./ ]*$/);
        let isValid = String(value.trim())
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateIsAlphabetsPunctuationsComments));
      }
      return Promise.resolve();
    },
  }),

  
  validateIsAlphabetsPunctations: (obj) => ({
    validator(name, value) {
      const specialCharacters = '!"#$%&\'()*+,-/:;<=>?@[\\]^_`{|}~';
      const allowedChars = /^(?!.*\.{2})[.\s\w]+$/;
      const lastCharacter = value && value.trim()[value.length - 1];
      let isValid = true;

      if (value) {
        if(String(value).toLowerCase().match(/^(?![0-9_])(?!.*[0-9_]$)(?!.*\d_)(?!.*_\d)[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]{2,}[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+$/) == null || specialCharacters.includes(lastCharacter) || !allowedChars.test(value)
      )
        isValid = false;
        else if(value.trim().length < 3){
          isValid = false; 
        }
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(i18next.t(validateErrMessages.validateIsAlphabetsPunctuations, { lng: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" })));
      }
      return Promise.resolve();
    },
  }),
  validateIsAlphabetsPunctationsNoLength: (obj) => ({
    validator(name, value) {
      if (value) {let isValid = String(value).toLowerCase().match(/^(?![0-9._])(?!.*[0-9._]$)(?!.*\d_)(?!.*_\d)[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]{0,}[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(i18next.t(validateErrMessages.validateIsAlphabetsPunctuations)));
      }
      return Promise.resolve();
    },
  }),

  validateIsAlphabets: (obj) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).toLowerCase().match(/^([a-zA-Z ]+)$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateIsAlphabets));

      }
      return Promise.resolve();
    },
  }),
  validateIsTestName: (obj) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).toLowerCase().match(/^.*[a-zA-Z][^a-zA-Z]*$/);

        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateIsTestName));

      }
      return Promise.resolve();
    },
  }),
  validateIsAlphabetsName: (obj) => ({
    validator(name, value) {
      const specialCharacters = '!"#$%&\'()*+,-/:;<=>?@[\\]^_`{|}~';
      const allowedChars = /^(?!.*\.{2})[.\s\w]+$/;
      const lastCharacter = value && value.trim()[value.length - 1];
      let isValid = true;
      if (value) {
        if(String(value).toLowerCase().match(/^(?![0-9_])(?!.*[0-9_]$)(?!.*\d_)(?!.*_\d)[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]{2,}[a-zA-Z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~ ]+$/) == null || specialCharacters.includes(lastCharacter)||String(value).toLowerCase().includes("_") || !allowedChars.test(value))
        isValid = false; 
      else if(value.trim().length < 3){
        isValid = false; 
      }
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateIsAlphabetsPunctuations));
      }
      return Promise.resolve();
    },
  }),
  checkOnlyAlphabets: (obj) => ({
    validator(name, value) {
      if (value) {
        value = String(value).trim()
        let isValid = String(value).toLowerCase().match(/^([a-zA-Z ]+)$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateIsAlphabets));

      }
      return Promise.resolve();
    },
  }),

  documentNumberIsAlphaNumeric: ({ getFieldName, getFieldValue }) => ({
    validator(name, value) {
      if (value) {
        value = String(value).trim()
        let isValid = String(value).toLowerCase().match(/^([a-zA-Z0-9 ]+)$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.documentNumberIsAlphaNumeric));
      }
      return Promise.resolve();
    },
  }),

  documentNumberIsNumber: ({ getFieldName, getFieldValue }) => ({
    validator(name, value) {
      if (value) {
        value = String(value).trim()
        let isValid = String(value).toLowerCase().match(/^([0-9 ]+)$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.documentNumberIsNumber));
      }
      return Promise.resolve();
    },
  }),

  documentNumberDuration: ({ getFieldName, getFieldValue }) => ({
    validator(name, value) {
      if (value) {
        value = String(value).trim()
        let limit = 1000;
        if(name.field.includes("dosage")) limit = 1000;
        if(name.field.includes("number_of_close_friends")) limit = 1000;
        if(name.field.includes("number_of_years")) limit = 99;
        if(name.field.includes("duration")) limit = 100;
        let isValid = String(value).toLowerCase().match(/^([0-9 ]+)$/);
        let isValidlimit = String(value) <= limit;
        if (isValid) 
        {
          if (isValidlimit) return Promise.resolve();
          else return Promise.reject(new Error(validateErrMessages.maxLimitErrorMessage));
        }
        else return Promise.reject(new Error(validateErrMessages.documentNumberIsNumber));
      }
     
     
      return Promise.resolve();
    },
  }),
  validateDuration : ({ getFieldValue }) => ({
    validator(_, value) {
      if (value === undefined || value === null || value === '') {
        return Promise.reject(new Error(validateErrMessages.validateDuration)); 
      }
      const valueStr = String(value).trim();
      let duration = Number(valueStr);
      if (duration <= 0) {
        return Promise.reject(new Error(validateErrMessages.greaterThanZero)); 
      }
      if (duration > 1000) {
        return Promise.reject(new Error(validateErrMessages.length1000ErrorMessage)); 
      }
      return Promise.resolve(); 
    },
}),
validateSubstanceDuration: (label, childLabel, show) => ({ getFieldValue }) => ({
  validator(_, value) {
      const durationId = getFieldValue([label, childLabel, "duration", "duration_id"]);
      const durationPeriod = value ? String(value).trim() : '';  
      if (show) {
        if (!durationPeriod && !durationId) {
          return Promise.reject(new Error(validateErrMessages.validateDuration));
        }
        if (!durationPeriod) {
          return Promise.reject(new Error(validateErrMessages.validateDurationPeriod));
        }
        if (!durationId) {
          return Promise.reject(new Error(validateErrMessages.validateDurationTime));
        }
      }
  
      return Promise.resolve();
  },
}),

  checkDosageFrequency: (obj) => ({
    validator(name, value) {
      if(value)
     { if (value.length==1?value.toUpperCase()!="P":value.length==2?value.toUpperCase() !="PR":value.toUpperCase() != "PRN") {
        let isValid = String(value).toLowerCase().match(/^(?!0-0-0-0+$)(?!0-0-0+$)(?!0-0+$)([0-4-]+)$/);

        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateDosageMessage));

      }
      return Promise.resolve();}
      else{
        return Promise.reject();
      }
    },
  }),
  checkDosageFrequencyDoubleDigits: (obj) => ({
    validator(name, value) {
      
      if (value.toUpperCase() != "PNR") {
        
        let isValid = String(value).toLowerCase().match(/^(?!0-0+$)([0-2-]+)$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateDosageMessage));
      }
      return Promise.resolve();
    },
  }),
  checkFrequencyPRN: (obj) => ({
    validator(name, value) {
      if (value) {
        let isValid = String(value).to().match(/^PRN$/);
        if (isValid) return Promise.resolve();
        else return Promise.reject(new Error(validateErrMessages.validateDosageMessage));
      }
      return Promise.resolve();
    },
  }),
  RemoveInitialSpace: (value) => {
    if(value && value.trim()) {
      while( value.charAt(0) === ' ' )
        value = value.slice(1);
      return value
    } 
  },
  validateJobChange: ({ getFieldName, getFieldInstance }) => ({
    validator(_, value) {
      if (value) {
        let isValid = String(value).toLowerCase().match(/^[1-9][0-9]?$|^10$/);
        if (isValid) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error(validateErrMessages.validateJobChangeMessage));
        }
      }
      return Promise.resolve();
    },
  }),
  checkWeight: ({ getFieldName, getFieldInstance }) => ({
    validator(_, value) {
      if (value) {
        let isValid = Number(value) >= 10 && Number(value) <= 200 ;
        if (isValid) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error(validateErrMessages.checkWeightMessage));
        }
      }
      return Promise.resolve();
    },
  }),
  checkHeight: ({ getFieldName, getFieldInstance }) => ({
    validator(_, value) {
      if (value) {
        let isValid = Number(value) >= 30 && Number(value) <= 200;
        if (isValid) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error(validateErrMessages.checkHeightMessage));
        }
      }
      return Promise.resolve();
    },
  }),
  checkZipCode: ({ getFieldName, getFieldInstance }) => ({
    validator(_, value) {
      if (value) {
        let isValid = String(value).toLowerCase().match(/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/);
        if (isValid) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error(validateErrMessages.checkZipCodeMessage));
        }
      }
      return Promise.resolve();
      // return Promise.reject(new Error());
    },
  }),
  validateAddress: ({ getFieldName, getFieldInstance }) => ({
    validator(_, value) {
      if (value) {
        let isValid = String(value).toLowerCase().match(/^[a-zA-Z0-9\s,./'-]{3,}$/);
        if (isValid) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error(validateErrMessages.validateAddressMessage));
        }
      }
      return Promise.reject(new Error());
    },
  }),
  validateLoginPassword: ({ getFieldValue, validateFields }) => ({
    validator(_, value) {
      if (value) {
        if (value?.includes(" ")) {
          return Promise.reject(new Error(validateErrMessages.noSpaceAllowed))
        }
        else if (value.length < 8) {
          return Promise.reject(
            new Error(validateErrMessages.validatePasswordMessage1)
          );
        }
        else if (value.length > 32) {
          return Promise.reject(
            new Error(validateErrMessages.validatePasswordMessage2)
          );
        }
        return Promise.resolve();
      }
      return Promise.reject(new Error());
    },
  }),
  validatePasswordHint: (allHintsSuccessful) => ({
    validator(_, value) { 
        if (!allHintsSuccessful)
          return Promise.reject(new Error(''))
        else
        return Promise.resolve();
      }
  }),
  validatePassword: ({ getFieldValue, validateFields }) => ({
    validator(_, value) {
      let validSpecialCase = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[+!@#$%^&*_])[\\w+!@#$%^&*_]{8,32}$")

      if (value) {
        if (value?.includes(" ")) {
          return Promise.reject('')
        }
        else if (value.length < 8) {
          return Promise.reject(
            new Error('')
          );
        }
        else if (value.length > 32) {
          return Promise.reject(
            new Error('')
          );
        }

        if (validSpecialCase.test(value) == false) {
          return Promise.reject(
            new Error('')
          );
        }
        return Promise.resolve();
      }
      return Promise.reject(new Error());
    },
  }),

  validateConfirmPassword:(tgtLang = null) =>  ({ getFieldValue }) => ({
    validator(_, value) {
      if (value) {
        // if (value?.includes(" ")) {
        //   return Promise.reject(new Error(validateErrMessages.noSpaceAllowed))
        // }
        // else if (value.length < 8) {
        //   return Promise.reject(
        //     new Error(validateErrMessages.validateConfirmPasswordMessage1)
        //   );
        // }
        // else if (value.length > 15) {
        //   return Promise.reject(
        //     new Error(validateErrMessages.validateConfirmPasswordMessage2)
        //   );
        // }
        // else 
        if (
          getFieldValue('password') &&
          value != getFieldValue('password')
        ) {
          return Promise.reject(
            new Error(i18next.t(validateErrMessages.validateConfirmPasswordMessage3, { lng: tgtLang ? tgtLang: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" }))
          );
        }
        return Promise.resolve();
      }
      return Promise.reject(new Error());
    },
  }),
  validateemailduplicate: (data) => ({
    validator(_, value) {
      if (
          value == data
        ) {
          return Promise.reject(
            new Error(validateErrMessages.validateemailduplicate)
          );
        }
      return Promise.resolve()//reject(new Error());
    },
  }),
  validatemobileduplicate: (data) => ({
    validator(_, value) {
      if (
          value == data
        ) {
          return Promise.reject(
            new Error(validateErrMessages.validatemobileduplicate)
          );
        }
      return Promise.resolve()//reject(new Error());
    },
  }),

  ValidateOtp: (value) => {
    if (value) {
      if (value.length < 4 || isNaN(value)) {
        return i18next.t(validateErrMessages.otpMessage1, { lng: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" });
      } else {
        return null;
      }
    } else {
      return i18next.t(validateErrMessages.otpMessage2, { lng: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" });
    }
  },
  mobileNumberTenDigit: ({ getFieldValue }) => ({
    validator(_, value) {
      if (value) {
        let zero_not_allowed = String(value).toLowerCase().match(/^(?:[1-9]\d*|0)$/);
        let isValid = String(value).toLowerCase()
          .match(
            /^(?:(?:\+|0{0,2})(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/
          );
        if (isValid && zero_not_allowed) {
          return Promise.resolve();
        } else {
          return Promise.reject(new Error(validateErrMessages.checkMobileNumberMessage));
        }
      }
      return Promise.resolve();
    },
  }),
  checkOnlyNumberForEducational: (obj) => ({
       validator(name, value) {
         if (value) {
           let isValid = String(value).toLowerCase().match(/^[0-9]*$/);
            if (isValid < 51) return Promise.resolve();
            else return Promise.reject(new Error(validateErrMessages.validateEducation));
    
          }
          return Promise.resolve();
        },
      }),
  validateTermAdolscent: (getFieldValue) => ({
    validator(_, value) {
      if (value)
        return Promise.resolve();
      else return Promise.reject(new Error(i18next.t(validateErrMessages.adolscentTermAndCondtion, { lng: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" })))
    }
  }),
  validateTermAndCondition: (getFieldValue) => ({
    validator(_, value) {
      if (value)
        return Promise.resolve();
      else return Promise.reject(new Error(i18next.t(validateErrMessages.termAndCondition, { lng: window?.store?.getState().loginReducer?.user_details.language +"_en" || "" })))
    }
  }),

  ValidatePrescriptionDiet:(obj)=>({
    validator(_, value){
      let regex = /^[A-Za-z\s]*$/;
      let isValid = true;

     if(value){
      if(value.every(element => regex.test(element) == true)){
        isValid = true;
       }
       else{
        isValid = false;
       } 
     }

     if(isValid){
      return Promise.resolve();
     }
     else{
      return  Promise.reject(new Error(validateErrMessages.validateIsAlphabetsOnly));
     }
    }
  }),


};
